import {
  VehicleCert,
  VehicleCertStatus
} from '../../services/endpoints/service29'

type Props = {
  certs: VehicleCert[]
  eligibleStatus: VehicleCertStatus
  variant: 'approve' | 'revoke'
  label: string
  selectedCerts: VehicleCert[]
  onChange: (selected: VehicleCert[]) => void
}

const CertSelectAll = ({
  certs,
  eligibleStatus,
  variant,
  label,
  selectedCerts,
  onChange
}: Props) => {
  const eligible = certs.filter((c) => c.status === eligibleStatus)
  const allSelected =
    eligible.length > 0 &&
    eligible.every((c) => selectedCerts.some((s) => s.id === c.id))

  const handleChange = () => {
    if (allSelected) {
      onChange(
        selectedCerts.filter((s) => !eligible.some((e) => e.id === s.id))
      )
    } else {
      onChange([
        ...selectedCerts,
        ...eligible.filter((e) => !selectedCerts.some((s) => s.id === e.id))
      ])
    }
  }

  return (
    <>
      <input
        type="checkbox"
        id="cert-select-all"
        className={`cert-select-check ${variant}`}
        checked={allSelected}
        onChange={handleChange}
      />
      <label htmlFor="cert-select-all">{label}</label>
    </>
  )
}

export default CertSelectAll
